export default {"src":"/_next/static/media/twitter.ceb2488e.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};